import { joinPaths, withQuery } from './url.js';
/** The six static apps and their serve prefixes. */
export const APP_BASE_PATHS = {
    /** 公开门户(首页/登录/注册/密码/条款/隐私)— 站点根。 */
    portal: '/',
    /** 玩家区(资料/白名单/皮肤/工单/通知)。 */
    'user-app': '/user',
    /** 管理后台。 */
    'admin-app': '/admin',
    /** Wiki 阅读。 */
    'wiki-reader': '/wiki',
    /** Wiki 编辑(嵌套在 reader 之下部署)。 */
    'wiki-editor': '/wiki/editor',
    /** EverQuest 编辑器(独立于 admin)。 */
    'quest-editor': '/quest-editor',
};
/**
 * A URL inside an app, e.g.
 *   appUrl('portal')                      → '/'
 *   appUrl('portal', '/login')            → '/login'
 *   appUrl('user-app', '/tickets')        → '/user/tickets'
 *   appUrl('user-app', '/tickets', { status: 'open' })
 *     → '/user/tickets?status=open'
 *
 * `path` may carry its own query string only when `query` is omitted —
 * passing both throws, so a hand-typed '?' never fights the serializer.
 */
export function appUrl(app, path = '', query) {
    if (query !== undefined && path.includes('?')) {
        throw new TypeError('appUrl: pass the query either in `path` or via `query`, not both');
    }
    return withQuery(joinPaths(APP_BASE_PATHS[app], path), query);
}
/** The serve prefix of the app a same-origin path belongs to, or undefined. */
export function appIdOfPath(path) {
    // Longest prefix first so /wiki/editor beats /wiki.
    const entries = Object.entries(APP_BASE_PATHS).sort((a, b) => b[1].length - a[1].length);
    for (const [app, base] of entries) {
        if (base === '/') {
            continue; // portal is the fallback owner of '/', never a prefix match
        }
        if (path === base || path.startsWith(`${base}/`)) {
            return app;
        }
    }
    return undefined;
}
//# sourceMappingURL=apps.js.map